export default [
  {
    path: '/reports/attendance',
    name: 'attendance-report',
    component: () => import("@/views/Page/Reports/AttendanceReport.vue"),
    meta: {
      title: '#Default# | Attendance Report',
      requiresAuth: true,
    },
  }
];

